var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74997 3.11114C10.0261 3.29524 10.0821 3.64346 9.87496 3.88892L6.40624 8L9.87496 12.1111C10.0821 12.3565 10.0261 12.7048 9.74997 12.8889C9.47382 13.073 9.08208 13.0232 8.87497 12.7777L5.125 8.33333C4.95833 8.1358 4.95833 7.8642 5.125 7.66667L8.87497 3.22225C9.08208 2.9768 9.47382 2.92705 9.74997 3.11114Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftIcon);
export default __webpack_public_path__ + "static/media/chevron-left-icon.26b81b526a395cb04c419a934ff491e9.svg";
export { ForwardRef as ReactComponent };